/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Move_UpInputs */



/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Audio_Embed_Export_Output_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_move_up = /** @type {((inputs?: Audio_Embed_Export_Output_Move_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Move_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Monter en gamme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufsteigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostarsi verso l'alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поднимитесь выше")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上へ進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बढ़ाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Suba")
	return /** @type {LocalizedString} */ ("Move up")
});